import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function BookCoverSection() {
  const {
    t,
    coverImage
  } = useLanguage();
  return <section className="relative w-full flex items-center justify-center overflow-hidden pt-6 pb-2 sm:pt-16 sm:pb-8" data-id="element-46">
      {/* Background glows */}
      <div className="absolute inset-0 pointer-events-none gpu-layer" data-id="element-47">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] sm:w-[700px] h-[400px] sm:h-[700px] bg-flame/10 rounded-full blur-[100px] sm:blur-[160px] animate-pulse" data-id="element-48" />
        <div className="absolute top-1/3 left-1/3 w-[300px] sm:w-[500px] h-[300px] sm:h-[500px] bg-magenta/8 rounded-full blur-[80px] sm:blur-[130px] animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-49" />
        <div className="absolute bottom-1/3 right-1/3 w-[250px] sm:w-[450px] h-[250px] sm:h-[450px] bg-purple-electric/8 rounded-full blur-[80px] sm:blur-[120px] animate-pulse" style={{
        animationDelay: '2s'
      }} data-id="element-50" />
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.88,
      y: 30
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      duration: 1.4,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative z-10 flex flex-col items-center gap-8" data-id="element-51">
        {/* Eyebrow label */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="font-sans text-xs tracking-[0.3em] uppercase text-gold/70" data-id="element-52">
          {t('bookCover.eyebrow')}
        </motion.p>

        {/* Book cover with glow */}
        <div className="relative animate-float gpu-layer" data-id="element-53">
          {/* Outer glow layers */}
          <div className="absolute -inset-10 sm:-inset-16 bg-gradient-to-br from-flame/35 via-magenta/25 to-teal/30 rounded-3xl blur-2xl sm:blur-3xl animate-pulse" data-id="element-54" />
          <div className="absolute -inset-8 bg-gradient-to-tr from-purple-electric/25 via-flame/20 to-gold/25 rounded-2xl blur-2xl" data-id="element-55" />
          <div className="absolute -inset-4 bg-gradient-to-bl from-teal/20 via-magenta/15 to-flame/20 rounded-xl blur-xl" data-id="element-56" />

          {/* Book image */}
          <div className="relative w-64 sm:w-80 md:w-96 rounded-xl overflow-hidden shadow-glow-psyche animate-psyche-pulse" data-id="element-57">
            <img src={coverImage} alt={t('bookCover.alt')} loading="eager" decoding="async" fetchPriority="high" className="w-full h-auto object-cover rounded-xl" data-id="element-58" />
            <div className="absolute inset-0 bg-gradient-to-t from-void/20 via-transparent to-transparent pointer-events-none" data-id="element-59" />
          </div>

          {/* Floating particles */}
          <div className="absolute -top-4 -right-4 w-3 h-3 bg-flame rounded-full blur-sm animate-pulse" data-id="element-60" />
          <div className="absolute -bottom-5 -left-3 w-2.5 h-2.5 bg-magenta rounded-full blur-sm animate-pulse" style={{
          animationDelay: '0.5s'
        }} data-id="element-61" />
          <div className="absolute top-1/4 -right-6 w-2 h-2 bg-teal-light rounded-full blur-sm animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-62" />
          <div className="absolute bottom-1/4 -left-5 w-2 h-2 bg-purple-electric-light rounded-full blur-sm animate-pulse" style={{
          animationDelay: '1.5s'
        }} data-id="element-63" />
          <div className="absolute top-1/2 -right-8 w-1.5 h-1.5 bg-gold-light rounded-full blur-sm animate-pulse" style={{
          animationDelay: '2s'
        }} data-id="element-64" />
          <div className="absolute -top-2 left-1/4 w-1.5 h-1.5 bg-flame-bright rounded-full blur-sm animate-pulse" style={{
          animationDelay: '2.5s'
        }} data-id="element-65" />
        </div>

        {/* Subtitle below cover */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="font-sans text-sm text-white/30 tracking-wide text-center max-w-xs" data-id="element-66">
          {t('bookCover.subtitle')}
        </motion.p>
      </motion.div>
    </section>;
}